import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from '@/utils';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
var BANNER_DATA = {
  imageurl: '',
  link_type: '1',
  link_value: ''
};
export default {
  name: 'goods_drawer_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        // header_image: [
        // 	{ required: true, message: '抽屉头部图片不可为空', trigger: 'change' }
        // ],
        id: [{
          required: true,
          message: '菜单不可为空',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '展示逻辑不可为空',
          trigger: 'change'
        }],
        show_more: [{
          required: true,
          message: '查看更多功能不可为空',
          trigger: 'change'
        }],
        more_name: [{
          required: true,
          message: '查看更多文案不可为空',
          trigger: 'change'
        }, {
          min: 4,
          max: 6,
          message: '仅可输入4-6字',
          trigger: 'blur'
        }],
        cols: [{
          required: true,
          message: '请选择每行展示产品数量',
          trigger: 'change'
        }]
      },
      showPictureLibrary: false,
      pictureInfo: {},
      pictureList: [],
      updateIndex: 0,
      pictureIndex: 1,
      depot: {},
      updateProp: ''
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureInfo = picture;
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (this.updateProp === 'header_image') {
        this.value.config.header_image = path;
      } else {
        this.value.config.banner[this.updateIndex]['imageurl'] = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(prop, pictureIndex, index) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.pictureIndex = pictureIndex;
      this.updateIndex = index;
      this.updateProp = prop;
      this.pictureList = this.pictureInfo[this.pictureIndex];
      this.showPictureLibrary = true;
    },
    checkNumber: function checkNumber(min, max, value, callback) {
      if (value === '') {
        return callback('产品展示行数不可为空');
      } else {
        if (!/^[0-9]*$/.test(value)) {
          callback('仅支持正整数');
        } else if (value > max || value < min) {
          callback("\u4EC5\u652F\u6301".concat(min, "-").concat(max, "\u6B63\u6574\u6570"));
        } else {
          callback();
        }
      }
    },
    onUpload: function onUpload(type) {
      if (type === 'header_image') {
        this.$refs.uploadHeader.uploadBanner();
      } else {
        this.$refs.uploadBanner[type].uploadBanner();
      }
    },
    emitUploadFile: function emitUploadFile(data, prop, url) {
      this.$set(data, prop, "".concat(this.$ossurl).concat(url));
    },
    onDelete: function onDelete(data, prop) {
      var _this2 = this;
      if (!data[prop]) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.$set(data, prop, '');
      }).catch(function (_) {});
    }
  },
  created: function created() {
    this.getPicture();
    var _this$value$config = this.value.config,
      _this$value$config$he = _this$value$config.header_image,
      header_image = _this$value$config$he === void 0 ? this.value.config_default_value.value.header_image : _this$value$config$he,
      _this$value$config$id = _this$value$config.id,
      id = _this$value$config$id === void 0 ? '' : _this$value$config$id,
      _this$value$config$ba = _this$value$config.banner,
      banner = _this$value$config$ba === void 0 ? [_objectSpread({}, BANNER_DATA)] : _this$value$config$ba,
      _this$value$config$co = _this$value$config.cols,
      cols = _this$value$config$co === void 0 ? '15' : _this$value$config$co,
      _this$value$config$ro = _this$value$config.rows,
      rows = _this$value$config$ro === void 0 ? '1' : _this$value$config$ro,
      _this$value$config$sh = _this$value$config.show_more,
      show_more = _this$value$config$sh === void 0 ? '2' : _this$value$config$sh,
      _this$value$config$mo = _this$value$config.more_name,
      more_name = _this$value$config$mo === void 0 ? '查看更多' : _this$value$config$mo,
      _this$value$config$bg = _this$value$config.bg_color,
      bg_color = _this$value$config$bg === void 0 ? '#ffffff' : _this$value$config$bg,
      _this$value$config$co2 = _this$value$config.content_padding_top,
      content_padding_top = _this$value$config$co2 === void 0 ? 30 : _this$value$config$co2,
      _this$value$config$so = _this$value$config.sort,
      sort = _this$value$config$so === void 0 ? '1' : _this$value$config$so,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread({
      header_image: header_image,
      id: id,
      banner: banner,
      cols: cols,
      rows: rows,
      show_more: show_more,
      more_name: more_name,
      bg_color: bg_color,
      content_padding_top: content_padding_top,
      sort: sort,
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index
    }, this.value.config));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      var list = JSON.parse(JSON.stringify(this.menuList));
      return list.map(function (i) {
        if (i.type === 'online_order') {
          i.childrens = i.childrens.map(function (c) {
            return _objectSpread(_objectSpread({}, c), {}, {
              disabled: true
            });
          });
        }
        return _objectSpread(_objectSpread({}, i), {}, {
          disabled: i.disabled || i.group_type == 2 // 组合菜单 禁止选择一级菜单
        });
      });
    }
  }
};